module.exports = __webpack_public_path__ + "static/media/Apple iPhone X Space Grey.ff35c1a3.png";